import { getSessionStorage } from '@/utils'
import {
  SESSION_STORAGE_TOKEN,
  SESSION_STORAGE_OPEN_ID,
  SESSION_STORAGE_USER_INFO,
  SESSION_STORAGE_BIND,
} from '@/config'
export default {
  token: getSessionStorage(SESSION_STORAGE_TOKEN)
    ? getSessionStorage(SESSION_STORAGE_TOKEN)
    : '',
  openId: getSessionStorage(SESSION_STORAGE_OPEN_ID)
    ? getSessionStorage(SESSION_STORAGE_OPEN_ID)
    : '',
  bind: getSessionStorage(SESSION_STORAGE_BIND)
    ? getSessionStorage(SESSION_STORAGE_BIND)
    : 'N',
  userInfo: getSessionStorage(SESSION_STORAGE_USER_INFO)
    ? getSessionStorage(SESSION_STORAGE_USER_INFO)
    : {},
}
